module.exports = __webpack_public_path__ + "assets/img/img271.75c73e05.png";